export const initDrawerMenu = () => {
  document.querySelectorAll<HTMLElement>("[data-drawer-menu]").forEach((blockElement) => {
    blockElement
      .querySelectorAll<HTMLElement>("[data-drawer-menu-handle]")
      .forEach((dropdownMenu) => {
        const handle = dropdownMenu.dataset.drawerMenuHandle;
        const url = dropdownMenu.dataset.drawerMenuUrl;
        const hasLinks = dropdownMenu.dataset.drawerMenuHasLinks === "true";
        const toggle = dropdownMenu.querySelector<HTMLButtonElement>(`[data-drawer-menu-toggle]`);
        const content = dropdownMenu?.querySelector<HTMLElement>("[data-drawer-menu-dropdown]");
        const icon = dropdownMenu?.querySelector<HTMLElement>("[data-drawer-menu-dropdown-icon]");
        const megaMenu = document.querySelector<HTMLElement>(
          `[data-header-link-megamenu="${handle}"][data-header-megamenu-visibility="md:hidden"],[data-header-link-megamenu="${handle}"][data-header-megamenu-visibility="responsive"]`
        );

        dropdownMenu.querySelectorAll<HTMLElement>("[data-drawer-sub-menu]").forEach((submenu) => {
          let active = submenu.classList.contains("active") || false;
          const button = submenu.querySelector<HTMLButtonElement>("[data-drawer-sub-menu-button]");
          const container = submenu.querySelector<HTMLButtonElement>(
            "[data-drawer-sub-menu-dropdown]"
          );

          if (!button || !container) {
            return;
          }

          button.addEventListener("click", (e) => {
            if (active) {
              submenu.classList.remove("active");
              container.style.maxHeight = "0";
              active = false;
            } else {
              e.preventDefault();
              e.stopPropagation();
              submenu.classList.add("active");
              container.style.maxHeight = container.scrollHeight
                ? `${container.scrollHeight}px`
                : "10000px";
              setTimeout(() => {
                if (active) {
                  container.style.maxHeight = "10000px";
                }
              }, 150);
              active = true;
            }
          });
        });

        const megamenuSections = megaMenu?.querySelectorAll<HTMLElement>(
          `[data-megamenu-handle="${handle}"] > section`
        );

        /* if (megaMenu) {
          return;
        }*/

        if (!hasLinks && !megamenuSections?.length) {
          return;
        }

        if (blockElement.classList.contains("grid-cols-2")) {
          dropdownMenu.classList.add("col-span-2", "order-first");
        }

        if (!handle || !toggle || !content) return;
        icon.classList.remove("hidden");

        let neverOpened = true;
        if (megamenuSections?.length) {
          let megamenuContent = "";
          megamenuSections.forEach((megamenuSection) => {
            megamenuContent = megamenuContent + megamenuSection.innerHTML;
          });
          content.firstElementChild.innerHTML = megamenuContent;
        }

        toggle.addEventListener("click", (e) => {
          if ((e.target as HTMLElement)?.hasAttribute("data-drawer-menu-view-all")) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();

          if (toggle.classList.contains("active")) {
            content.style.maxHeight = "0px";
            toggle.classList.remove("active");
            return;
          }
          document.dispatchEvent(new Event("scroll-slider-update"));

          setTimeout(() => {
            document.dispatchEvent(new Event("scroll-slider-update"));
          }, 150);
          if (neverOpened) {
            content.style.maxHeight = `${9999999}px`;
            toggle.classList.add("active");
            neverOpened = false;

            return;
          }

          content.style.maxHeight = `${content.scrollHeight}px`;
          setTimeout(() => {
            if (toggle.classList.contains("active")) {
              content.style.maxHeight = `${9999999}px`;
            }
          }, 150);
          toggle.classList.add("active");
        });
      });
  });
};
